export default __webpack_public_path__ + "static/media/epigro_3.437069fa.png";